export default {
	getCompanyList(state) {
		return state.companyList;
	},
	getCompanyObj(state) {
		return state.companyObj;
	},
	getUserMessage(state) {
		return state.UserMessage;
	},
	getEditableTabs(state) {
		return state.editableTabs;
	},
	getIsAndroid(state) {
		return state.isAndroid;
	},
}
